import { fetchProcessingDealsStatus as fetchProcessingDealsStatusRequest } from '../api/forecastApi';
import { FETCH_PROCESSING_DEALS_STATUS } from './ActionTypes';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export function fetchProcessingDealsStatus() {
  return dispatch => fetchProcessingDealsStatusRequest().then(data => dispatch({
    type: FETCH_PROCESSING_DEALS_STATUS,
    payload: data
  })).catch(error => logRavenException(error, 'Fetch processing deals status'));
}